
import { FC, useEffect, useState } from 'react'
import clsx from 'clsx'
import { KTIcon, toAbsoluteUrl } from '../../../helpers'
import { useAuth } from '../../../../app/modules/auth'
import {
  HeaderNotificationsMenu,
  HeaderUserMenu,
  QuickLinks,
  Search,
  ThemeModeSwitcher,
} from '../../../partials'
import { jwtDecodingService } from '@/core/services/jwt-decoding-service'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '@/store'
import { fileService } from '@/projects/platform/services/file-service'
import { resetUploadState } from '@/store/upload/upload-slice'
import { profile } from 'console'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarButtonHeightClass = 'btn-active-light-primary btn-custom w-40px h-40px w-md-40px h-md-40p',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px'
//toolbarButtonIconSizeClass = 'fs-1',
const toolbarButtonIconSizeStyle: React.CSSProperties = { fontSize: "1.9rem" }



function Topbar() {
  const { auth } = useAuth()
  const dispatch = useDispatch(); 
  const jwt = jwtDecodingService.getDecodedAccessToken(auth?.access_token);
  const profileImageUploaded = useSelector((state: RootState) => state.upload.profileImageUploaded);

 const [profileImage, setProfileImage] = useState<string | undefined>(undefined);

  useEffect(() => {
    (async function () {
      const result = await fileService.getProfileImageAsync();
      setProfileImage(result.data.image);
    })();
    dispatch(resetUploadState());
  }, [profileImageUploaded]);


  let logo = '';
  let sizeClass = 'h-25px'
  if (jwt.accountId === '559bed70-3552-4d64-8627-91170b6610fa') {
    logo = "/logo/cocacola.svg";
  }
  if (jwt.accountId == '2c5f6dbc-b2d9-4f51-b5eb-0d7bd562a546') {
    logo = "/logo/syncflow.png";
    sizeClass = 'h-45px'
  }

  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>
      <div className='topbar d-flex align-items-stretch flex-shrink-0'>

        {/* CHAT */}
        {/* <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
          <div
            className={clsx(
              'btn btn-icon btn-active-light-primary btn-custom position-relative',
              toolbarButtonHeightClass
            )}
            id='kt_drawer_chat_toggle'
          >
            <img src='/obase-air.png' alt="icon" className='h-35px w-35px' />
          </div>
        </div> */}
        {/* begin::Theme mode */}
        {/* <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
          <ThemeModeSwitcher toggleBtnClass={toolbarButtonHeightClass} />
        </div> */}
        {/* end::Theme mode */}

        {logo && (<div className='header-logo ms-5 flex-grow-1 flex-lg-grow-0'>
          <img
            alt='Logo'
            src={logo}
            className={'logo-default ' + sizeClass}
          />
          <img
            alt='Logo'
            src={logo}
            className={'logo-sticky ' + sizeClass}
          />
        </div>)}
        {/* begin::User */}
        <div
          className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
          id='kt_header_user_menu_toggle'
        >
          {/* begin::Toggle */}
          <div
            className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
            data-kt-menu-trigger='click'
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='bottom'
          >
            <span className='version-number1-4'></span>
            {profileImage !== undefined && (
              <img
                alt="Logo"
                src={
                  profileImage
                    ? `data:image/png;base64,${profileImage}`
                    : "/logo/07804c87-9a27-4b5b-9092-fadb2f043faf.png"
                }
                onError={(e) => {
                  if (profileImage) {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = "/logo/07804c87-9a27-4b5b-9092-fadb2f043faf.png";
                  }
                }}
              />
            )}




          </div>
          <HeaderUserMenu profileImage={profileImage} />
          {/* end::Toggle */}
        </div>
        {/* end::User */}
      </div>
    </div>
  )
}

export { Topbar }
